import React from 'react'
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import {version} from "pdfjs-dist"
const PdfView = ({ fileLink, ...props }) => {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return (
        <Worker workerUrl={`https://unpkg.com/pdfjs-dist@${version}/build/pdf.worker.min.js`}>
            <Viewer
                style={{ backgroundColor: "red" }}
                fileUrl={fileLink}
                plugins={[
                    defaultLayoutPluginInstance
                ]}
                {...props}
            />
        </Worker>
    )
}

export default PdfView